/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React, { useEffect, useState } from 'react';
import { VERSION, COMMIT_ID, BRANCH } from '../../utils/version';

import './version.scss';

const version = require('b_').with('widget-version');

const clearVersion = v => v && v.replace(new RegExp(/[^0-9.]+/g), '');
const VERSION_TITLE = 'Версия';

export const Version = () => {
    const [ fe, setFEVersion ] = useState({});

    useEffect(() => {
        setFEVersion({ version: clearVersion(VERSION) });
    }, []);

    const branchInfo = BRANCH && COMMIT_ID ? ` (${BRANCH} #${COMMIT_ID})` : '';

    return (
        <>
            <span className={version()} title={BRANCH ? `Ветка: ${BRANCH}\nКоммит: ${COMMIT_ID}` : undefined}>
                {`${VERSION_TITLE} ${Object.values(fe).join('-')}`}{branchInfo}
            </span>
        </>
    );
};
